// extracted by mini-css-extract-plugin
export var container = "_73-0";
export var infoButton = "_73-1";
export var label = "_73-3";
export var labelExpanded = "_73-4";
export var price = "_73-5";
export var priceExpanded = "_73-6";
export var title = "_73-2";